import styled from "styled-components";
import { Caption } from "src/affiliate/styled/typography.styled";

export const StyledCaption = styled(Caption)`
    margin-bottom: 32px;
`;

export const StyledSpan = styled.span`
    color: #ffffff;
`;